export const setCustomerFoodMenuList = (dispatch) => ({
    type: "GET_FOOD_MENU",
    payLoad: dispatch,
  });